(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    function collapseFacetsOnMobile(){
    try {
      if (window.innerWidth >= 750) return;
      document.querySelectorAll('.facets details[open]').forEach(d => {
        d.removeAttribute('open');
      });
    } catch(e){}
  }
  document.addEventListener('DOMContentLoaded', collapseFacetsOnMobile, { once: true });
  // Only add resize listener once and use debounce to reduce calls
  if (!window.facetsResizeListenerAdded) {
    window.facetsResizeListenerAdded = true;
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(collapseFacetsOnMobile, 150);
    }, { passive: true });
  }

  // Auto-submit custom sort and preserve query params
  document.addEventListener('change', function(e){
    const sel = e.target.closest('.custom-sorting__select');
    if(!sel) return;
    const form = sel.closest('form');
    if(!form) return;
    try {
      const url = new URL(window.location.href);
      // keep all params but override sort_by
      url.searchParams.set('sort_by', sel.value);
      window.location.href = url.toString();
    } catch(err) {
      form.submit();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
